// extracted by mini-css-extract-plugin
export default {"modal":"RF-z","sharingIconsV2":"SF-z","notificationBox":"TF-z","checkMark":"UF-z","textFrame":"VF-z"};